import { render } from "./MessageInner.vue?vue&type=template&id=46c9ded9&scoped=true"
import script from "./MessageInner.vue?vue&type=script&lang=js"
export * from "./MessageInner.vue?vue&type=script&lang=js"

import "./MessageInner.vue?vue&type=style&index=0&id=46c9ded9&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c9ded9"]])

export default __exports__